<form [formGroup]="form">
  <div
    class="quiz-block"
    cdkDropList
    [cdkDropListData]="answers.controls"
    (cdkDropListDropped)="drop($event)"
  >
    <div
      *ngFor="let data of answers.controls; let index = index"
      class="option-row"
      cdkDrag
      [cdkDragData]="data"
      formArrayName="answers"
    >
      <div class="answer-block" [formGroupName]="index">
        <label for="{{ data.label }}">{{ data.label }}</label>
        <div class="form-controls">
          <button class="nobutton control-icon action-icon">
            <mat-icon
              color="primary"
              class="material-icons-outlined control-icon action-icon"
              >drag_indicator</mat-icon
            >
          </button>

          <mat-checkbox
            class="form-field form-control"
            color="primary"
            name="correct-{{ quiz.position }}-{{ index }}"
            id="correct-{{ quiz.position }}-{{ index }}"
            aria-label="Correct Answer Checkbox"
            formControlName="correct"
          >
          </mat-checkbox>

          <div class="form-field">
            <mat-form-field>
              <input
                name="answer"
                id="answer"
                matInput
                type="text"
                class=""
                placeholder="Add answer, max 140 characters"
                aria-label="Answer Textbox"
                formControlName="answer"
                maxlength="140"
              />
            </mat-form-field>
          </div>
          <ng-container *ngIf="hasImage(index)">
            <div class="image-preview">
              <img [src]="getImageSrc(index)" alt="Image Preview" />
            </div>
          </ng-container>
          <button
            (click)="fileUpload.click()"
            class="nobutton"
            *ngIf="!hasImage(index)"
          >
            <input
              formControlName="file"
              name="file"
              id="file"
              type="file"
              #fileUpload
              [multiple]="fileConfig.canUploadMultiple"
              style="display: none"
              [accept]="fileConfig.allowedMimeTypeList.join(',')"
              (change)="onFileSelect($event.target.files, index)"
            />
            <mat-icon
              color="primary"
              class="material-icons-outlined control-icon action-icon"
              >image</mat-icon
            >
          </button>
          <button
            (click)="delete(data.id || index)"
            class="nobutton"
            [disabled]="imageSavePending"
          >
            <mat-icon
              color="primary"
              class="material-icons-outlined control-icon action-icon"
              >delete</mat-icon
            >
          </button>
        </div>
      </div>
    </div>
    <button
      class="icon-button button"
      mat-raised-button
      color="secondary"
      (click)="addOption($event)"
      [disabled]="imageSavePending"
    >
      <span>
        <mat-icon color="primary">add</mat-icon>
        {{ addText | uppercase }}
      </span>
    </button>
  </div>
</form>
